import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ListItem } from '../../core/models/list-item';
import { SearchCriteria } from '../models/search-criteria';

@Component({
  selector: 'irar-site-details',
  template: `
      <div>
        <h2>AOC Description for {{siteName}}</h2>
      </div>
      <div [innerHTML]="description" style="margin-bottom:15px;"></div>
      <button (click)="showDocuments()">Show Documents</button>
      <p-dialog [modal]="true" [showHeader]="false" [(visible)]="loading">
        <div style="text-align:center">Loading Documents</div>
      </p-dialog>
  `
})
export class SiteDetailComponent {
  @Input() site: ListItem;
  @Input() loading: boolean;
  @Output() getDocuments: EventEmitter<SearchCriteria> = new EventEmitter();

  get siteName() {
    if (!this.site) { return ''; }
    return this.site.abbreviation + ' (' + this.site.title + ')';
  }

  get description() {
    if (!this.site) { return ''; }
    return this.site.description;
  }

  showDocuments() {
    const criteria = new SearchCriteria();
    criteria.site = [this.site.abbreviation];
    this.getDocuments.emit(criteria);
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/site-detail.ts